import { render, staticRenderFns } from "./DishTemperature.vue?vue&type=template&id=05905d70&scoped=true"
import script from "./DishTemperature.vue?vue&type=script&lang=js"
export * from "./DishTemperature.vue?vue&type=script&lang=js"
import style0 from "./DishTemperature.vue?vue&type=style&index=0&id=05905d70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05905d70",
  null
  
)

export default component.exports